import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  FilterOrder,
  SearchFilterFacet,
  SortOption,
} from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

const ENDPOINT = `${APIConfiguration.search}filteredorders`;

export interface FilterFacetValue {
  name: string;
  label?: string;
  included: boolean;
}

interface FilterOrdersCommandArgs {
  query?: string;
  pageSize?: number;
  page?: number;
  isDescending?: boolean;
  sort?: string;
  filters?: SearchFilterFacet[];
  dateTimeFilters?: DateTimeFilter[];
  sortOptions?: SortOption[];
  sellerId?: string;
  tenantId?: string;
}

async function filterOrdersCommand({
  query,
  filters,
  page,
  pageSize,
  sort,
  isDescending,
  dateTimeFilters,
  sortOptions,
  sellerId,
  tenantId,
}: FilterOrdersCommandArgs): Promise<
  BackResponse<SearchResultList<FilterOrder>> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<SearchResultList<FilterOrder>>>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.POST,
        json: {
          query,
          filters,
          page,
          pageSize,
          sort,
          isDescending,
          dateTimeFilters,
          sortOptions,
          sellerId,
          tenantId,
        },
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default filterOrdersCommand;
